module.exports = __webpack_public_path__ + "static/media/filtered.a875b6d2.geojson";